// Display/analytics only. Financial entitlements are never written by this script.
// Member prices are native Shopify automatic discounts at normal checkout; there is no bag intercept.
(function(){
  var dialog=document.getElementById('RunItClubDialog'), opener;
  // Consent: RunItAnalytics.capture is a no-op until the visitor allows analytics in the cookie
  // bar (Shopify customerPrivacy) and PostHog has loaded, so nothing is sent before consent.
  function track(name,props,key){if(window.RunItAnalytics)window.RunItAnalytics.capture(name,Object.assign({source_page:location.pathname},props||{}),key);}
  // Full Club page only (the homepage block has no data-club-page). Tried on DOMContentLoaded
  // (runit-analytics.js is deferred after this file) and again when consent loads PostHog;
  // the dedupe key keeps it to one view.
  function pageView(){if(document.querySelector('[data-club-page]'))track('club_page_view',null,'club_page_view:'+location.pathname);}
  if(document.readyState==='complete')pageView();else document.addEventListener('DOMContentLoaded',pageView,{once:true});
  document.addEventListener('runit:posthog-ready',pageView);
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-club-open]');
    if(open&&dialog&&typeof dialog.showModal==='function'){e.preventDefault();opener=open;dialog.showModal();track('club_join_click');}
    if(dialog&&(e.target.closest('[data-club-close]')||e.target===dialog))dialog.close();
    if(e.target.closest('[data-club-join]'))track('club_join_click');
  });
  if(dialog)dialog.addEventListener('close',function(){if(opener&&opener.isConnected)opener.focus();});
  // Join bar (phones): show only between the join panel scrolling away and the final join section arriving.
  var bar=document.querySelector('[data-club-bar]'),joinPanel=document.getElementById('join'),finalJoin=document.querySelector('.rlc-final'),past=false,reached=false;
  if(bar&&joinPanel&&'IntersectionObserver' in window){
    var sync=function(){bar.classList.toggle('is-shown',past&&!reached);};
    new IntersectionObserver(function(entries){var e=entries[0];past=!e.isIntersecting&&e.boundingClientRect.top<0;sync();}).observe(joinPanel);
    if(finalJoin)new IntersectionObserver(function(entries){var e=entries[0];reached=e.isIntersecting||e.boundingClientRect.top<0;sync();}).observe(finalJoin);
  }
})();
